import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SEO from "@/components/SEO";
import { PageHero, CTABand } from "@/components/PageHero";
import { Section, SectionHeading } from "@/components/Primitives";
import { COUNTRIES } from "@/data/content";

export default function CountriesIndex() {
  return (
    <>
      <SEO title="Countries" description="Business setup, market entry and investment support across Malaysia, Canada, the UK, Pakistan and India. Contact us to know more." path="/countries" />
      <PageHero eyebrow="Global Service Network" title="Where We Support Your Business"
        subtitle="Explore how Global Pass Consultants coordinates company setup, market entry and business support across our service network." />
      <Section className="bg-white">
        <SectionHeading eyebrow="Countries" title="Select a Market" />
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {COUNTRIES.map((c) => (
            <Link key={c.slug} to={`/countries/${c.slug}`} className="group rounded-2xl bg-white border border-slate-100 overflow-hidden hover-lift">
              <div className="h-44 overflow-hidden"><img src={c.image} alt={c.name} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" /></div>
              <div className="p-6">
                <div className="flex items-center gap-2"><span className="text-2xl">{c.flag}</span><h3 className="font-bold text-navy text-lg">{c.name}</h3></div>
                <p className="mt-2 text-sm text-slate-500">{c.tagline}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-emerald-brand group-hover:gap-2 transition-all">View {c.name} services <ArrowRight size={14} /></span>
              </div>
            </Link>
          ))}
        </div>
      </Section>
      <CTABand />
    </>
  );
}
